var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import createAuth0Client from '@auth0/auth0-spa-js';
import { PortalBootstrapService } from './portal-bootstrap.service';
import { TeamService } from './team.service';
import * as i0 from "@angular/core";
import * as i1 from "./portal-bootstrap.service";
import * as i2 from "./team.service";
/**
 * Thin Angular wrapper around @auth0/auth0-spa-js — instantiates the underlying
 * Auth0Client lazily using whatever Auth0 config the portal advertises through
 * COM_PortalSettings (loaded by PortalBootstrapService at app startup).
 *
 * Portals that don't have Auth0 enabled never instantiate the client.
 */
export class Auth0ClientService {
    constructor(bootstrap, teamService) {
        this.bootstrap = bootstrap;
        this.teamService = teamService;
        this.clientPromise = null;
    }
    get isEnabledForPortal() {
        return this.bootstrap.auth0Enabled
            && !!this.bootstrap.auth0Config.domain
            && !!this.bootstrap.auth0Config.clientId;
    }
    getClient() {
        if (!this.isEnabledForPortal) {
            return Promise.reject(new Error('Auth0 is not enabled for the current portal.'));
        }
        if (!this.clientPromise) {
            const teamCode = this.getTeamCode();
            const options = {
                domain: this.bootstrap.auth0Config.domain,
                client_id: this.bootstrap.auth0Config.clientId,
                audience: this.bootstrap.auth0Config.audience,
                redirect_uri: `${window.location.origin}/${teamCode}/auth0-callback`,
                cacheLocation: 'localstorage',
                useRefreshTokens: true
            };
            this.clientPromise = createAuth0Client(options);
        }
        return this.clientPromise;
    }
    loginWithRedirect(returnTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield this.getClient();
            const options = {};
            if (returnTo) {
                options.appState = { returnTo };
            }
            yield client.loginWithRedirect(options);
        });
    }
    handleRedirectCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield this.getClient();
            const result = yield client.handleRedirectCallback();
            return (result && result.appState) ? result.appState : null;
        });
    }
    isAuthenticated() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isEnabledForPortal) {
                return false;
            }
            try {
                const client = yield this.getClient();
                return client.isAuthenticated();
            }
            catch (_a) {
                return false;
            }
        });
    }
    getAccessTokenSilently(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield this.getClient();
            return client.getTokenSilently(options);
        });
    }
    logout(returnToPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield this.getClient();
            const teamCode = this.getTeamCode();
            const fallback = `${window.location.origin}/${teamCode}/login`;
            const options = {
                returnTo: returnToPath || fallback
            };
            client.logout(options);
        });
    }
    // Resolves the portal/team code for building redirect URLs. Prefers the resolved team
    // template, but falls back to the first URL path segment (e.g. /omonoia/... -> 'omonoia')
    // so the Auth0 redirect_uri always includes the portal even if the template isn't set yet.
    getTeamCode() {
        if (this.teamService.teamTemplate && this.teamService.teamTemplate.teamId) {
            return this.teamService.teamTemplate.teamId;
        }
        const segments = window.location.pathname.replace(/^\//, '').split('/');
        return segments[0] || '';
    }
}
Auth0ClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Auth0ClientService_Factory() { return new Auth0ClientService(i0.ɵɵinject(i1.PortalBootstrapService), i0.ɵɵinject(i2.TeamService)); }, token: Auth0ClientService, providedIn: "root" });
